export const getReferrals = ({ orderBy, direction, ...payload }) => ({
    [`order[${orderBy}]`]: direction, // boolean, true if direction is ASC
    ...payload,
});
